import React from 'react';
import ProgramTab from "../../common/ProgramTab";

const GeorgiaProgramTab = () => {

    const daysContent = [
        {
            day: 'day1',
            day_title: 'georgia_d1',
            content: 'georgia_program_d1'
        },
        {
            day: 'day2',
            day_title: 'georgia_d2',
            content: 'georgia_program_d2'
        },
        {
            day: 'day3',
            day_title: 'georgia_d3',
            content: 'georgia_program_d3'
        },
        {
            day: 'day4',
            day_title: 'georgia_d4',
            content: 'georgia_program_d4'
        },
        {
            day: 'day5',
            day_title: 'georgia_d5',
            content: 'georgia_program_d5'
        },
        {
            day: 'day6',
            day_title: 'georgia_d6',
            content: 'georgia_program_d6'
        },
        {
            day: 'day7',
            day_title: 'georgia_d7',
            content: 'georgia_program_d7'
        },
    ];

    return (
        <ProgramTab daysContent={daysContent}/>
    );
};

export default GeorgiaProgramTab;
